import React from 'react'
import Lottie from 'lottie-react'
import ConfetiAnime from '../../lotties/confeti.json'
import wordings from '../../wording.json'
import { SupportedLanguage } from '../VoiceRoom'

type EndProps = {
  lang: string
}

export const Confeti = (): JSX.Element => {
  return (
    <div className="confetti-container">
      <Lottie animationData={ConfetiAnime} loop={true} autoplay={true} aria-label="confetti" />
    </div>
  )
}

const End: React.FC<EndProps> = (props: EndProps) => {
  const langu: SupportedLanguage = (
    props.lang in wordings ? props.lang : 'default'
  ) as SupportedLanguage
  const content = wordings[langu]
  const message = content.endMessage ?? 'It’s been great talking with you. Thanks again!'
  return (
    <div className="overlay">
      <Confeti />
      <div className="modal">
        <p>{message}</p>
      </div>
    </div>
  )
}

export default End
